import { h } from "preact";
import { useDispatch } from "react-redux";

import i18n from "../i18n";
import { setGlobalError } from "../store";
import Icon from "./Icon.jsx";

export default function GlobalError({ error }) {
  const dispatch = useDispatch();

  function handleCloseGlobalError() {
    dispatch(setGlobalError(null));
  }

  return (
    <p class="alert alert--error alert--flash" role="alert">
      {error}
      <Icon class="alert__closer" onClick={handleCloseGlobalError}>
        close
      </Icon>
    </p>
  );
}
